import { useEffect } from 'react';
import { fetchEpstQuestionsSectionType } from 'api/certifications/epst/questions';
import { handleApiError, selectQuestionsByLevelAndSection, shuffleArray } from 'utils';

/**
 * Hook que carga las preguntas del EPST según la sección actual.
 *
 * @param {Object} params
 * @param {number} params.step - Paso actual del examen.
 * @param {Function} params.setQuestions - Setter para actualizar las preguntas en el componente padre.
 * @param {Object} params.certification - Objeto de la certificación con ID y tipo de candidato.
 * @param {string} params.token - Token JWT para autenticación en la API.
 * @param {Function} params.setLoading - Setter para mostrar u ocultar el loader.
 */
const useEpstQuestionsLoader = ({ step, setQuestions, certification, token, setLoading }) => {
	useEffect(() => {
		const loadQuestions = async () => {
			if (![2, 4, 6, 8, 10].includes(step)) return;
			try {
				setLoading(true);
				const sectionId = step / 2;
				const { data } = await fetchEpstQuestionsSectionType(sectionId, certification.candidate_type, token);
				if (data.status === 200) {
					const filtered = selectQuestionsByLevelAndSection(data.message, sectionId, certification.candidate_type);
					const shuffled = shuffleArray(filtered);
					setQuestions(shuffled);
				}
			} catch (error) {
				handleApiError(error);
			} finally {
				setLoading(false);
			}
		};
		loadQuestions();
	}, [step, certification, token, setQuestions, setLoading]);
};

export default useEpstQuestionsLoader;